import React from "react";

import InfiniteScrolling from "../infinite-scrolling";
import FetchInactiveUploads from "./fetch-inactive-uploads";
import InactiveUpload from "./inactive-upload";
import Modal from "../../../containers/modal";

const InfinitePendingUploads = ({ uploads, loadMoreUploads }) => {
    return (
        <section
            id="pending"
            className="infinite-page user-icons container row"
        >
            <div className="container moderator-letter-container">
                <div className="moderator-letter">
                    <h1>A letter from your Curators</h1>
                    <p>Thank you for contributing to Noun Project</p>
                    <p>
                        Please note, current moderation processing time is{" "}
                        <b>about 18 weeks</b>. We receive thousands of icons
                        each day from creators around the world, and review each
                        individually to maintain high standards of design,
                        technical quality, and ethical consideration. We have
                        recently expanded our curation team to help support our
                        growing community faster. You can help us expedite
                        processing by making sure icon titles and tags are
                        directly relevant and spelled correctly, and by adhering
                        to our guidelines which can be{" "}
                        <a
                            href="/handbook/create/#technical_guidelines"
                            target="_blank"
                            className="text-link dark"
                            style={{ color: "#000" }}
                        >
                            found here.
                        </a>
                    </p>
                    <p>We appreciate your patience!</p>
                    <p>– Your Curation Team</p>
                </div>
            </div>

            <header className="display-flex col-xs-12">
                <h3 className="ui_upload">Awaiting moderation</h3>
                <span className="back-link">
                    <a href="/dashboard">Dashboard</a>
                </span>
            </header>

            <ul id="pending-uploads" className="col-xs-12 dashboard-user">
                {uploads.length ? (
                    <InfiniteScrolling
                        loadMore={loadMoreUploads}
                        elements={
                            uploads &&
                            uploads.map(upload => (
                                <InactiveUpload
                                    key={upload.id}
                                    upload={upload}
                                />
                            ))
                        }
                    />
                ) : (
                    <h2>There aren't any uploads to show</h2>
                )}
            </ul>
        </section>
    );
};

export default function InfinitePendingUploadsWrapper() {
    return (
        <div>
            <FetchInactiveUploads limit={20} offset={0} uploadState="pending">
                <InfinitePendingUploads />
            </FetchInactiveUploads>
            <Modal />
        </div>
    );
}
